import Layout from '@/layout/index.vue';
import { agentsSubMenu } from './subMenus/agents-sub-menu';
import { dealersRolesSubMenu } from './subMenus/dealers-roles-sub-menu';
import { dealersUserSubMenu } from './subMenus/dealers-user-sub-menu';
import { agentsUserSubMenu } from './subMenus/agents-user-sub-menu';
import { dealersAddressSubMenu } from './subMenus/dealers-address-sub-menu';
import { dealersTransporterSubMenu } from './subMenus/dealers-transporter-sub-menu';
const dealerRouter = {
  path: '/dealers',
  component: Layout,
  redirect: 'noredirect',
  name: 'dealerManagement.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Unit Manager', 'Account Manager', 'Invoice Manager', 'Agent', 'Branch Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Sales Manager', 'Order Manager', 'Payment Manager'],
    title: 'dealerManagement.title',
    icon: 'peoples'
  },
  children: [{
    path: 'list',
    component: () => import('@/views/dealers/list.vue'),
    name: 'dealerManagement.dealer.title',
    meta: {
      title: 'dealerManagement.dealer.title',
      noCache: true,
      icon: 'peoples'
    }
  }, {
    path: 'add',
    component: () => import('@/views/dealers/manage.vue'),
    name: 'dealerManagement.dealer.add',
    props: {
      isEdit: false
    },
    meta: {
      roles: ['Super Admin', 'Admin'],
      title: 'dealerManagement.dealer.add',
      noCache: true,
      hidden: true,
      activeMenu: '/dealers/list'
    }
  }, {
    path: 'edit/:id(\\d+)',
    component: () => import('@/views/dealers/manage.vue'),
    name: 'dealerManagement.dealer.edit',
    props: {
      isEdit: true
    },
    meta: {
      roles: ['Super Admin', 'Admin'],
      title: 'dealerManagement.dealer.edit',
      noCache: true,
      hidden: true,
      activeMenu: '/dealers/list'
    }
  }, ...dealersRolesSubMenu, ...dealersAddressSubMenu, ...dealersUserSubMenu, ...agentsSubMenu, ...agentsUserSubMenu, ...dealersTransporterSubMenu]
};
export default dealerRouter;